import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=12cdf08f&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=12cdf08f&prod&scoped=true&lang=css"
import style1 from "./ProfileDetails.vue?vue&type=style&index=1&id=12cdf08f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cdf08f",
  null
  
)

export default component.exports